import React from 'react'
import Tooltip from './Tooltip'

export default ({ status, children, className, useBareClass, ...props }) => (
  <div className={`${useBareClass || 'fs18-sm d-sm-ib'} ${className || ''}`}>
    <Tooltip {...props} content={children} placement='right'>
      { status ? <i className='icon-access-status-good status-active' /> : 
       <i className={`icon-access-status-warning status-inactive`} />
      }              
    </Tooltip>
  </div>
)



// WEBPACK FOOTER //
// ./client/src/components/AppStatusIndicator.js